import { PropertyCategoryGQL } from "./External";
function createEnumObject<T extends string>(o: { [P in T]: P }) {
  return o;
}

export const PropertyCategory = createEnumObject<PropertyCategoryGQL>({
  Bungalow: "Bungalow",
  Agriculture: "Agriculture",
  Flat: "Flat",
  House: "House",
  Industrial: "Industrial",
  Land: "Land",
  Maisonette: "Maisonette",
  Office: "Office",
  Other: "Other",
  Park_Home: "Park_Home",
  Retail: "Retail",
});
